import { Stack } from 'expo-router';

export default function AssetManagementLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false
      }}
    >
      <Stack.Screen name={'index'} />
    </Stack>
  );
}
